import React from "react";
import { Box, Flex } from "theme-ui";
import { Testimonial } from "../molecules";

const TestimonialSection = ({
  testimonials,
}) => {
  return (
    <Box sx={{ mx: 'auto' }}>
      <Flex
        sx={containerStyle}
      >
        {testimonials?.slice(0, 2).map((testimonial) => {
          return (
            <Testimonial
              variant="secondary"
              subVariant="secondaryOne"
              image={testimonial.testimonialImage?.gatsbyImageData}
              imageAltText={testimonial.testimonialImageAltText}
              feedback={testimonial.feedback}
              employeeName={testimonial.employeeName}
              employeeDesignation={testimonial.employeeDesignation}
              rating={testimonial.rating}
              companyName={testimonial.companyName}
              companyLogo={testimonial.companyLogo?.gatsbyImageData}
              companyLogoAltText={testimonial.companyLogoAltText}
              innerContainerCustomStyles={{
                minHeight: ["20.125rem", "20.125rem", "21.625rem", "24.188rem"]
              }}
              customStyles={{
                "@media(min-width: 600px)": {
                  my: "-4rem"
                }
              }}
            />
          );
        })}
      </Flex>
    </Box>
  );
};

const { containerStyle } = {
  containerStyle: {
    justifyContent: "center",
    alignItems: "center",
    gap: ["1.5rem", "1.5rem", "3rem", "3rem"],
    flexDirection: ["column", "column", "row", "row"],
  },
};

export default TestimonialSection;